import { Component,  EventEmitter,  Input, OnDestroy, OnInit, Output } from '@angular/core';
import { filterActions, FilterGroupTypes, filterPageTypes, filterTypes } from 'src/app/store/filters.era';
import { performerActions, TableFilterTypes, tableFilterTypes } from 'src/app/store/performers.era';
import { EditColumnsData, EditColumnsDialogComponent } from 'src/app/modules/workforce/edit-columns.dialog.component';
import { FiltersDialogComponent } from '../filters/filters-dialog.component';
import { FilterDialogComponentParams } from '../filters/filters-ui.models';
import { canAddReselector } from './../../store/reselectors/permissions.reselector';
import { Wrapper } from '../wrapper.component';
import { ColumnOrderType } from 'globals/store/settings.data';
import { ActionButtonComponent } from './action-button.component';
import { IconTextComponent } from '../buttons/icon-text.component';
import { SearchBarComponent } from '../search-bar';
import { CommonModule } from '@angular/common';
import { TaskToggleMenuComponent } from '../task-toggle-menu/task-toggle-menu.component';

@Component({
    selector: 'command-menu',
    template: `
<div class="command_menu">
  <search-bar *ngIf="!hideSearch" [gray]="inverted" (keyword)="search($event)"></search-bar>
  <icon-text *ngIf="!!filterText" [ngClass]="{ noSearch: hideSearch }" [text]="filterText" [active]="!!actualFilterCount" (click)="openFilters()"></icon-text>
  <div style="flex:1"></div>
  <div class="command" *ngIf="canEditColumns" (click)="editColumns()">Edit columns</div>
  <action-button *ngIf="(canAddItem || forceShowAddItem) && addItemText" [ngClass]="{ desktop: hideButtonMobile }" (click)="addItem.emit($event)" [text]="addItemText"></action-button>

  <ng-content select=".right-slot"></ng-content>
  <div *ngIf="showDottedMenu" class="actions">
    <app-task-toggle-menu [showMarkAllRead]="false"  [showDetailOptions]="showDetailOptions" [showSortOptions]="false" [lightDots]="false" [showHideTasks]="showHideTasks" [filterPage]="filterPage" [showExport]="showExport" (onExport) ="onExport.emit()" [showImport]="showImport" (onImport)="onImport.emit()" > 
    </app-task-toggle-menu>
  </div>
</div>
`,
    styleUrls: ['./command-menu.scss'],
    standalone: true,
    imports: [TaskToggleMenuComponent, ActionButtonComponent, IconTextComponent, SearchBarComponent, CommonModule],
})
export class CommandMenuComponent extends Wrapper<CommandMenuComponent> implements OnInit, OnDestroy {
  @Input() filterPage: keyof FilterGroupTypes
  @Input() filterType: keyof TableFilterTypes
  @Input() columnType: ColumnOrderType
  @Input() filterText: string
  @Input() showDottedMenu: boolean
  @Input() hideSearch: boolean = false
  @Input() hideButtonMobile = false
  @Input() showDetailOptions: boolean = true
  @Input() showExport: boolean
  @Input() showImport: boolean
  @Input() showHideTasks = false
  @Input() canEditColumns: boolean
  @Input() addItemText: string
  @Input() forceShowAddItem = false
  @Input() inverted = false
  @Input() editColumnsTitle: string
  canAddItem = false

  @Output() addItem: EventEmitter<Event> = new EventEmitter()
  @Output() onExport: EventEmitter<void> = new EventEmitter()
  @Output() onImport: EventEmitter<void> = new EventEmitter()
  actualFilterCount: number

  ngOnInit() {
    // console.log(`${this.filterPage} being created`)
    this.subProp(this.store.select('filters', this.filterPage, 'count'), 'actualFilterCount')
    if (this.filterType) this.store.dispatch(performerActions.changeTableFilters(this.filterType))
    this.subProp(this.store.select(canAddReselector), 'canAddItem')
  }

  ngOnDestroy() {
    // console.log(`${this.filterPage} being destroyed`)
    if (this.filterType) this.store.dispatch(performerActions.changeTableFilters(tableFilterTypes.NoFilters))
  }

  
  async openFilters() {
    let filterGroupings
    console.log("Opening filters for: " + this.filterPage)
    switch(this.filterPage) {
      case filterPageTypes.exhibitors:
        filterGroupings = await this.filtersService.buildExhibitorTableFilterUI()
        break
      case filterPageTypes.exhibitor_stands:
        filterGroupings = await this.filtersService.buildExhibitorTableFilterUI(true)
        break
      case filterPageTypes.allTasks:
        filterGroupings = await this.filtersService.buildTaskPageFilterUI(filterPageTypes.allTasks, true)
        break
      case filterPageTypes.myTasks:
        filterGroupings = await this.filtersService.buildTaskPageFilterUI(filterPageTypes.myTasks)
        break
      case filterPageTypes.tasksTable:
        filterGroupings = await this.filtersService.buildTaskPageFilterUI(filterPageTypes.tasksTable)
        break
      case filterPageTypes.allTasksCalendar:
        filterGroupings = await this.filtersService.buildTaskPageFilterUI(filterPageTypes.allTasksCalendar, true)
        break
      case filterPageTypes.taskTime:
        filterGroupings = await this.filtersService.buildTaskPageFilterUI(filterPageTypes.taskTime)
        break
      case filterPageTypes.asset_table:
        filterGroupings = await this.filtersService.buildAssetTableFilterUI()
        break
      case filterPageTypes.attendees:
        filterGroupings = await this.filtersService.buildAttendeeTableFilterUI()
        break
      case filterPageTypes.resources:
        filterGroupings = await this.filtersService.buildResourceTableFilterUI(false)
        break
      case filterPageTypes.programTable:
        filterGroupings = await this.filtersService.buildProgramTableFilterUI()
        break
      case filterPageTypes.performersTable:
      case filterPageTypes.sponsors:
      case filterPageTypes.performerSessionsTable:
      case filterPageTypes.sponsors:
        filterGroupings = await this.filtersService.buildPerformerOrSponsorSessionTableFilterUI(this.filterPage)
        break;
      case filterPageTypes.quotes:
        filterGroupings = await this.filtersService.buildResourceTableFilterUI(true)
        break;
      default:
        console.log("No filters builder for " + this.filterPage)
        return
    }
    if (!filterGroupings) return console.log("Missing filter groupings for " + this.filterPage)
    const isNarrow = [filterPageTypes.allTasks, filterPageTypes.myTasks, filterPageTypes.tasksTable, filterPageTypes.allTasksCalendar, filterPageTypes.asset_table].map(t => t as string).includes(this.filterPage)
    const params: FilterDialogComponentParams = { width: isNarrow ? '380px' : '770px', autoFocus: false, data: { filterPage: this.filterPage, filterGroupings }}
    this.dialog.open(FiltersDialogComponent, params);
  }


  editColumns() {
    const data: EditColumnsData = { type: this.columnType || this.filterPage as ColumnOrderType, title: this.editColumnsTitle || 'Edit Columns' }
    this.dialog.open(EditColumnsDialogComponent, { width: '480px', disableClose: true,
     data })
     
  }


  search(keyword: string) {
    this.store.dispatch(filterActions.updateFilter({ filterPageType: this.filterPage, filterType: filterTypes.search, value: keyword }))
  }


}

